
import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';


interface MenuState {
  solicitacoesRenovacao: number;
  reclamacoes: number;
  estabelecimentosAnalise: number;
  chefeSeccao: number;
  chefeDepartamento: number;
  inspeccoes: number;
  analiseInspeccoes: number;
  directorGeral: number;
  estabelecimentosReprovados: number;
  expediente: number;
  solicitacoesDesalfandegamento: number;
}

type MenuProps = {
  styles: string
}

export default function MenuDlifLicenciamento({ styles }: MenuProps) {
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    solicitacoesRenovacao: 0,
    reclamacoes: 0,
    estabelecimentosAnalise: 0,
    chefeSeccao: 0,
    chefeDepartamento: 0,
    inspeccoes: 0,
    analiseInspeccoes: 0,
    directorGeral: 0,
    estabelecimentosReprovados: 0,

    expediente: 0,
    solicitacoesDesalfandegamento: 0
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)


  useEffect(() => {
    api.get(`/menu/dlif`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'menu licenciamento'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.estabelecimentosAnalise} icone={'/icones/Licenciamento.svg'} nomeService={'Solicitações de Licenciamento'} link={'/admin/recepcao/solicitacoes-de-licenciamento?page=1'} />
        <CardServices load={loadMenu} count={menu.estabelecimentosReprovados} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitações Reprovadas'} link={'/admin/solicitacoes/reprovadas?page=1'} />
        <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.solicitacoesRenovacao} icone={'/icones/renovacaoLicenciamento.svg'} nomeService={'Solicitações de Renovação'} link={'/admin/solicitacoes-de-renovacao?page=1'} />
        {/* <CardServices load={loadMenu} count={menu.expediente} icone={'/icones/expediente/entrada.svg'} nomeService={'Expediente'} link={'/admin/expediente'} /> */}
      </Box>


      <Box className={styles}>
        <CardServices funcao='Chefe de Secção' load={loadMenu} count={menu.chefeSeccao} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Secção'} link={'/admin/chefe-da-seccao/solicitacoes-de-licenciamento?page=1'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/chefe-do-departamento/solicitacoes-de-licenciamento?page=1'} />
        <CardServices load={loadMenu} count={menu.inspeccoes} icone={'/icones/inspeccaoAgendarVisita.svg'} nomeService={'Inspecção'} link={'/admin/inspeccao-agendada/solicitacoes-de-licenciamento?page=1'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analiseInspeccoes} icone={'/icones/chefeDepartamento.svg'} nomeService={'Análise da inspecção'} link={'/admin/analise-inspeccao/solicitacoes-de-licenciamento?page=1'} />
        <CardServices funcao='Director Geral' load={loadMenu} count={menu.directorGeral} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/director-geral/solicitacoes-de-licenciamento?page=1'} />
      </Box>
    </Container>
  )
}





